import { generalInfoSchema } from '@eventr/common'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { z } from 'zod'
import { useEditItem } from '../hooks/useEditItem'
import { EventInfoRoutes } from './routes'
import { useIpInfo } from '@eventr/common-storybook'

export function getGeneralSchema() {
    return generalInfoSchema
}
export type GeneralInfoValidationSchema = z.infer<
    ReturnType<typeof getGeneralSchema>
>
const defaultNewActivity = {
    OSMAddress: {
        timeZone: useIpInfo.getState()?.timeZones?.[0] ?? 'Europe/London',
    },
}
export const EventInfoEditPage = () => {
    const item = useEditItem(1)

    const methods = useForm({
        resolver: zodResolver(getGeneralSchema()),
        shouldFocusError: true,
    })

    useEffect(() => {
        const newItem = new URLSearchParams(window.location.search).get('new')
        const isNew = newItem === 'true'
        const initialData = isNew ? defaultNewActivity : item
        methods.reset(initialData, {
            keepDirty: false,
        })
    }, [item, methods])

    return (
        <FormProvider {...methods}>
            <EventInfoRoutes />
        </FormProvider>
    )
}
